module.exports = __webpack_public_path__ + "img/shipo-icon-trending-down.3014ed20.svg";